import { render, staticRenderFns } from "./mySkeleton.vue?vue&type=template&id=2549da78&scoped=true"
import script from "./mySkeleton.vue?vue&type=script&lang=js"
export * from "./mySkeleton.vue?vue&type=script&lang=js"
import style0 from "./mySkeleton.vue?vue&type=style&index=0&id=2549da78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2549da78",
  null
  
)

export default component.exports